import { Box, Modal } from "@mui/material";
import "./chooseExamType.scss";
import { BrandButton, BrandButtonWhite } from "./form/buttons";
import { useQuery } from "react-query";
import { ApiEndpoint, pageIds } from "./utils";
import axios from "axios";
import Loader from "./loader";
import { useState } from "react";

interface Props {
  open: boolean;
  setExamType: (type: number | string) => void;
}

interface PageResponse {
  standardHeadline?: string;
  extendedHeadline?: string;
  standardDescription?: string | TrustedHTML | undefined ;
  extendedDescription?: string | TrustedHTML| undefined ;
  footerDescription?: string | TrustedHTML| undefined ;
}

const ChooseExamType = ({ open, setExamType }: Props) => {
  const [data, setdata] = useState<PageResponse | null>();

  const { isLoading } = useQuery("welecomePageData", async () => {
    const resp = await axios.get(
      ApiEndpoint + "wp-json/satapp-api/v1/getPageText?slug=" + pageIds.homepage
    );
    setdata(resp.data as PageResponse);
  });

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="chooseExamType">
        {isLoading ? (
          <Loader />
        ) : (
          <div className="box-holder">
            <div>
              <p className="boxHeadline">{data?.standardHeadline}</p>
              <p
                className="content"
                dangerouslySetInnerHTML={{
                  __html: (data?.standardDescription as string),
                }}
              />
              <p className="buttonHolder">
                <BrandButtonWhite onClick={() => setExamType("0.0")}>
                  CONTINUE
                </BrandButtonWhite>
              </p>
            </div>
            <div>
              <p className="boxHeadline">{data?.extendedHeadline}</p>
              <p
                className="content"
                dangerouslySetInnerHTML={{
                  __html: (data?.extendedDescription as string),
                }}
              />
              <p className="buttonHolder">
                <BrandButton onClick={() => setExamType("1.0")}>
                  CONTINUE
                </BrandButton>
              </p>
            </div>
          </div>
        )}
      </Box>
    </Modal>
  );
};
export default ChooseExamType;
